import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import Tab, { Tabs } from '@/components/elements/Button/TabButton';
import RaceProgramInfo, {
  PageType,
} from '@/components/layouts/Race/Singlerace/RaceProgramInfo';
import { RaceProgram } from '@/lib/apollo/types/gen/graphql';
import { getVelodromeByCode } from '@/lib/race/velodrome';
import { RaceType } from '@/modelTypes';

import { Headline } from '../../style';
import {
  BackLink,
  BackLinkArea,
  Container,
  HeldDate,
  RaceProgramInfoWrapper,
  TabWrapper,
} from './style';

export interface ResultTemplateProps {
  raceProgram: RaceProgram;
  racePrograms?: RaceProgram[];
}

const ResultTemplate: FC<
  ResultTemplateProps & {
    raceType: RaceType;
    children: React.ReactNode;
    width?: string;
  }
> = ({ raceProgram, racePrograms, raceType, children, width }) => {
  const navigate = useNavigate();

  return (
    <Container width={width}>
      <Headline>
        レース結果
        <HeldDate>{raceProgram.heldDate.format('YYYY年M月D日')}</HeldDate>
      </Headline>
      <TabWrapper>
        <Tabs>
          <Tab
            active={raceType === RaceType.Singlerace}
            onClick={() =>
              navigate(
                `/${
                  getVelodromeByCode(raceProgram.velodromeCode).romanName
                }/race/${raceProgram.heldDate.format('YYYY-MM-DD')}/result`,
                { state: { cancelScroll: true } },
              )
            }
          >
            競輪投票
          </Tab>
          <Tab
            active={raceType === RaceType.Multirace}
            onClick={() =>
              navigate(
                `/${
                  getVelodromeByCode(raceProgram.velodromeCode).romanName
                }/lottery/${raceProgram.heldDate.format('YYYY-MM-DD')}/result`,
                { state: { cancelScroll: true } },
              )
            }
          >
            チャリロト・Dokanto!
          </Tab>
        </Tabs>
      </TabWrapper>
      <RaceProgramInfoWrapper>
        <RaceProgramInfo
          raceProgram={raceProgram}
          racePrograms={racePrograms}
          pageType={PageType.Result}
        />
      </RaceProgramInfoWrapper>
      {children}
      <BackLinkArea>
        <BackLink
          to={`/results?date=${raceProgram.heldDate.format(
            'YYYY-MM-DD',
          )}&type=${raceType}`}
        >
          レース結果一覧
        </BackLink>
      </BackLinkArea>
    </Container>
  );
};

export default ResultTemplate;
